/// <reference path="skyward.ui.window.js"/>
(
    function (skyward, $, undefined)
    {
        skyward.collapsepanel = skyward.collapsepanel || {};

        var init = function (selector)
        {
            if ($('.collapsePanel').length > 0)
            {
                $(selector + ' div .toCollapse').removeClass('expanded toCollapse').addClass('collapsed');
            }

        };

        var toggle = function (contents, header, expanded)
        {
            var remove = expanded ? 'expanded' : 'collapsed';
            var add = expanded ? 'collapsed' : 'expanded';
            var text = expanded ? "Expand" : "Collapse";
            var findSelector = expanded ? ".collapse" : ".expand";

            skyward.svg.swapSvg(header.find(findSelector), text, 'CollapsePanel');

            contents.removeClass(remove);
            contents.addClass(add);

            header.attr('alt', text + " this region");

            $(window).resize();
        };

        var resizePanels = function ()
        {
            $('.collapsePanel').each(function ()
            {
                var panel = $(this);

                var unlockedHeader = panel.find('.unlockedHeader');
                if (unlockedHeader.length > 0)
                {
                    unlockedHeader.width(panel.width() - 5);
                }

                var unlockedBrowseBody = panel.find('.unlockedBrowseBody');
                if (unlockedBrowseBody.length > 0)
                {
                    unlockedBrowseBody.width(panel.width() - 5);
                }

                var footer = panel.find('.browseFooter');
                if (footer.length > 0)
                {
                    footer.width(panel.width() - 5);
                }

                var browseControls = panel.find('.toolbar--browseControls');
                if (browseControls.length > 0)
                {
                    browseControls.width(panel.width() - 5);
                    browseControls.width(panel.width() - 5);
                }
            });
        };

        //Public Methods
        skyward.collapsepanel.show = function (collapsePanel)
        {
            var header = collapsePanel.find('.collapsePanelHeader');
            var contents = collapsePanel.find('.collapsePanelContents');

            if (contents.hasClass('collapsed'))
            {
                toggle(contents, header, false);
                resizePanels();
            }
        };

        skyward.collapsepanel.toggleParent = function (collapseHeaderButton)
        {
            var collapseHeader = $(collapseHeaderButton).parent();
            skyward.collapsepanel.toggle(collapseHeader);
        };

        skyward.collapsepanel.toggle = function (collapseHeader)
        {
            var header = $(collapseHeader);
            var contents = header.siblings('.collapsePanelContents');
            toggle(contents, header, contents.hasClass('expanded'));

            resizePanels();
        };

        skyward.collapsepanel.expandAll = function ()
        {
            $('.collapsePanel').each(function ()
            {
                var contents = $(this).children('.collapsePanelContents');
                var header = $(this).children('.collapsePanelHeader');
                if (contents.hasClass('collapsed'))
                {
                    toggle(contents, header, false);
                }
            });
        };

        skyward.collapsepanel.collapseAll = function ()
        {
            $('.collapsePanel').each(function ()
            {
                var contents = $(this).children('.collapsePanelContents');
                var header = $(this).children('.collapsePanelHeader');
                if (contents.hasClass('expanded'))
                {
                    toggle(contents, header, true);
                }
            });
        };

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);
        skyward.window.registerLayoutResizeCallback(resizePanels);

    }(window.skyward = window.skyward || {}, window.jQuery)
);